import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef, useCallback } from "react";
import classnames from "classnames";
import { Power3, TweenLite, Draggable } from "gsap/all";
import { useWindowWidth } from "@react-hook/window-size";
import { polygon, centroid } from "@turf/turf";
import Icon from "../Icon";
import styles from "./MarkersMap.module.scss";

function getMin(a, b) {
  return 1 * a.reduce(function (a, c) {
    return c[b] < a ? c[b] : a;
  }, a[0][b]);
}

function getMax(a, b) {
  return 1 * a.reduce(function (a, c) {
    return c[b] > a ? c[b] : a;
  }, a[0][b]);
}

var getMinimumXY = function getMinimumXY(a) {
  return [getMin(a, "x"), getMin(a, "y")];
},
    getMaximumXY = function getMaximumXY(a) {
  return [getMax(a, "x"), getMax(a, "y")];
},
    percentageToPx = function percentageToPx(a, b) {
  return Math.trunc(a / 100 * b);
},
    INITIAL_SCALE = .8,
    DEFAULT_MARKERS_SCALE = 1.2;

export var MarkersMap = function MarkersMap(a) {
  var b = a.className,
      c = a.levels,
      d = a.onMarkerClick,
      e = a.activeMarker,
      f = a.zoom,
      g = useWindowWidth(),
      h = _slicedToArray(c || [], 1),
      i = h[0],
      j = useState(1.2),
      k = _slicedToArray(j, 2),
      l = k[0],
      m = k[1],
      n = useState(!1),
      o = _slicedToArray(n, 2),
      p = o[0],
      q = o[1],
      r = useState(i || {}),
      s = _slicedToArray(r, 2),
      t = s[0],
      u = s[1],
      v = t.markers,
      w = useRef(null),
      x = useRef(null),
      z = useRef(null),
      A = useCallback(function (a) {
    var b = (a || {}).zoom,
        c = e,
        d = _slicedToArray(c.coordinates, 2),
        f = d[0],
        h = d[1],
        i = 2 === c.coordinates.length,
        j = 3 <= c.coordinates.length,
        k = j ? polygon([[].concat(_toConsumableArray(c.coordinates.map(function (a) {
      var b = a.x,
          c = a.y;
      return [1 * b, 1 * c];
    })), [[1 * f.x, 1 * f.y]])]) : null,
        l = k ? centroid(k) : null,
        n = l ? l.geometry.coordinates : i ? [Math.abs((parseInt(f.x) + parseInt(h.x)) / 2), Math.abs((parseInt(f.y) + parseInt(h.y)) / 2)] : [],
        o = _slicedToArray(n, 2),
        p = o[0],
        r = o[1],
        s = getMinimumXY(c.coordinates),
        t = _slicedToArray(s, 2),
        u = t[0],
        v = t[1],
        A = getMaximumXY(c.coordinates),
        B = _slicedToArray(A, 2),
        C = B[0],
        D = B[1],
        E = j || i ? p : parseInt(C),
        F = j || i ? r : parseInt(D),
        G = Math.trunc(Math.abs(z.current.x)),
        H = z.current.target.parentNode.parentNode.clientWidth,
        I = G + H / 2,
        J = z.current.target.clientWidth,
        K = percentageToPx(E, J),
        L = Math.abs(K - I);

    j && (L -= 50); // get the direction of travel by checking if the marker is on the
    // left side or the right side of the middle point (marker > xMiddlePoint)

    var M = 0 === L ? "none" : K > I ? "left" : "right",
        N = "left" === M ? "-=".concat(L) : "+=".concat(L),
        x = Math.trunc(Math.abs(z.current.y)),
        O = z.current.target.parentNode.parentNode.clientHeight,
        P = x + O / 2,
        Q = z.current.target.clientHeight,
        R = percentageToPx(F, Q),
        S = Math.abs(R - P); // console.log("currentX", currentX);
    // console.log("markerX", markerX);
    // console.log("wrapperWidth", wrapperWidth);
    // console.log("xMiddlePoint", xMiddlePoint);
    // console.log("distanceX", distanceX);
    // console.log("directionX", directionX);
    // console.log("=======================");

    450 >= g && j && (S += 20); // get the direction of travel by checking if the marker is on the
    // left side or the right side of the middle point (marker > yMiddlePoint)

    var T = 0 === S ? "none" : R > P ? "top" : "bottom",
        U = "top" === T ? "-=".concat(S) : "+=".concat(S),
        y = percentageToPx(C, J) - percentageToPx(u, J),
        V = j ? H / y : INITIAL_SCALE;
    .45 > V && (V = .45);
    var W = percentageToPx(D, Q) - percentageToPx(v, Q),
        X = j ? O / W : INITIAL_SCALE; // .to(map.current, 0.8, {
    //   scale: xScale // isMobile ? yScale : [xScale, yScale],
    // });
    // const timeline = new TimelineMax();
    //
    // timeline
    //   .to(map.current, 0.8, {
    //     x,
    //     y,
    //     scale: 1,
    //     ease: Power3.easeInOut,
    //     onUpdate: () => draggable.current.update(true)
    //   })
    //   .to(
    //     map.current,
    //     0.8,
    //     {
    //       scale: 1.3,
    //       ease: Power3.easeIn
    //       // onUpdate: () => draggable.current.update(true)
    //     },
    //     0.5
    //   );

    return .45 > X && (X = .45), TweenLite.to(w.current, .8, {
      x: N,
      y: U,
      snap: {
        x: function x(a) {
          return parseInt(a);
        },
        y: function y(a) {
          return parseInt(a);
        }
      },
      scale: b ? b : j ? Math.min(V, X) - .1 : INITIAL_SCALE,
      // isMobile ? yScale : [xScale, yScale],
      ease: Power3.easeInOut,
      onUpdate: function onUpdate() {
        z.current.update(!0), w.current.style.zIndex = 9;
      }
    }), b ? (m(b + DEFAULT_MARKERS_SCALE), q(!0)) : (m(j ? Math.min(V, X) - .1 + INITIAL_SCALE : DEFAULT_MARKERS_SCALE), q(!1)), function () {};
  }, [e, g]);

  useEffect(function () {
    return u(i);
  }, [i]), useEffect(function () {
    if (f && w.current) {
      var a = function a() {
        w.current.style.zIndex = 9;
      };

      z.current = new Draggable(w.current, {
        type: "x,y",
        bounds: x.current,
        onPress: a,
        onDrag: a,
        liveSnap: !0,
        snap: {
          x: function x(a) {
            return parseInt(a);
          },
          y: function y(a) {
            return parseInt(a);
          }
        }
      });
    }
  }, [f, t]), useEffect(function () {
    f && setTimeout(function () {
      return A();
    }, 10);
  }, [f, e, e.id, A, g]);
  return t.colour || (t.colour = "black"), /*#__PURE__*/React.createElement("div", {
    className: classnames(b, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    ref: x,
    className: styles.wrapper
  }, p ? null : /*#__PURE__*/React.createElement("button", {
    className: styles.reset,
    onClick: function resetZoom() {
      return A({
        zoom: .5
      });
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "reset",
    className: styles.icon
  })), /*#__PURE__*/React.createElement("div", {
    ref: w,
    className: styles.map
  }, /*#__PURE__*/React.createElement("img", {
    src: t.image,
    alt: t.name // style={{ width: "100%" }}

  }), /*#__PURE__*/React.createElement("img", {
    src: "/img/amenities_zoom.png",
    alt: "Zoom",
    className: classnames(styles.amenitieszoom, "ta--amenities-zoom")
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.markers
  }, /*#__PURE__*/React.createElement("style", null, ".markers-active-colour:after { border-color: ".concat(t.colour, " !important; }")), v.map(function (a, b) {
    if (!a) return null;
    if (!a.coordinates) return null;
    if (!a.coordinates.length) return null;
    var c = e.id === a.id;
    return a.coordinates.map(function (e, f) {
      var g;
      return /*#__PURE__*/React.createElement("button", {
        key: "markers-".concat(a.id || b, "-").concat(f),
        className: classnames((g = {}, _defineProperty(g, styles.active, c), _defineProperty(g, "marker-active", c), g), "markers-active-colour", styles.marker),
        style: {
          left: "".concat(e.x, "%"),
          top: "".concat(e.y, "%"),
          backgroundColor: t.colour,
          transform: "scale(".concat(l, ")")
        },
        onClick: function onClick() {
          return d(a);
        }
      }, b + 1);
    });
  })))));
};
export default MarkersMap;